import ArticleType from "components/Content/RelatedArticles/PropTypes/ArticleType";
import classNames from "classnames";
import EmptyFigure from "components/Content/RelatedArticles/EmptyFigure";
import Figure from "components/Content/RelatedArticles/Figure";
import PropTypes from "prop-types";
import React from "react";

import styles from "../styles.scss";

export default function Article({ article, last }) {
  const classes = classNames(styles.article, "related-article", "grid-four", { "grid-last": last });
  const { image, title: titleHtml, url } = article;
  const title = { __html: titleHtml };

  return (
    <div className={classes}>
      <article>
        { image ? <Figure articleUrl={url} image={image} /> : <EmptyFigure /> }
        <header>
          <h2>
            <a href={url}>
              <span dangerouslySetInnerHTML={title} />
            </a>
          </h2>
        </header>
      </article>
    </div>
  );
}

Article.propTypes = {
  article: ArticleType.isRequired,
  last: PropTypes.bool.isRequired,
};
